import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=6e13b98c&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e13b98c')) {
      api.createRecord('6e13b98c', component.options)
    } else {
      api.reload('6e13b98c', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=6e13b98c&", function () {
      api.rerender('6e13b98c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pgI17chdc2DK/JS/comp/childrenage.vue"
export default component.exports